// Core
import { Suspense } from 'react';
// Components
import { InputSkeleton } from '../Skeleton';
import lazyWithPreload from 'helpers/lazyWithPreload';
import type { ITimeZoneSelectProps } from './TimeZoneSelectField';

// react-timezone-select brings react-select and a timezone database (67 KB gzip). It sits in a form
// that opens in a modal, so its code is fetched when the field first renders, not with every page
// that has such a modal; `preloadTimeZoneSelect` lets the app fetch it in the background.
const TimeZoneSelectField = lazyWithPreload(() => import('./TimeZoneSelectField'));

export const preloadTimeZoneSelect = TimeZoneSelectField.preload;

const TimeZoneSelect = (props: ITimeZoneSelectProps) => (
  <Suspense fallback={<InputSkeleton size={props.size} />}>
    <TimeZoneSelectField {...props} />
  </Suspense>
);

export default TimeZoneSelect;
